import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import Item from '../../components/Item';
import Image from '../../components/Image';
import stackedCardsImg from './stacked-cards.png';

import messages from './messages';
import './styles.css';

const NoResults = ({ intl: { formatMessage } }) => (
  <Item styleName="no-results-container">
    <Item.Content styleName="no-results-container-content">
      <Image src={stackedCardsImg} alt={formatMessage(messages.welcomeToTravelPlan)} centered />
      <Item.Header as="h3"><FormattedMessage {...messages.welcomeToTravelPlan} /></Item.Header>
      <Item.Description><FormattedMessage {...messages.welcomeToTravelPlanDescription} /></Item.Description>
    </Item.Content>
  </Item>
);

NoResults.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(NoResults);
